<template>
    <BaseForm>
        <template #fields>
            <ComboboxField
                :value="selectedCycle"
                :label="$t('cycle')"
                :error-messages="errors.cycle"
                :items="CYCLE_ITEMS"
                @change="setFieldValue('cycle', $event?.id ?? '')"
                @blur="setFieldTouched('cycle', true)"
            />
            <TextAreaField
                :value="values.cycleChanges"
                :label="$t('cycle-changes')"
                :error-messages="errors.cycleChanges"
                :max-length="EventSeriesCycle.shape.cycleChanges.maxLength ?? undefined"
                @input="setFieldValue('cycleChanges', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('cycleChanges', true)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import ComboboxField from '@/components/Form/ComboboxField.vue';
import TextAreaField from '@/components/Form/TextAreaField.vue';
import { useEventSeriesInjection } from '@/event/composables/useEventSeriesInjection';
import { CYCLE_ITEMS, EventSeriesCycle } from '@/event/forms/schemas';
import { useForm } from '@/forms/composables/useForm';
import { computed } from 'vue';

const props = defineProps<{ seriesId: string }>();

const seriesId = computed(() => props.seriesId);
const { series, updateEventSeries } = useEventSeriesInjection();

const { errors, values, setFieldValue, setFieldTouched, validate, onDiscard, resetForm } = useForm(
    EventSeriesCycle,
    computed(() => ({
        cycle: series.value?.cycle ?? '',
        cycleChanges: series.value?.cycleChanges ?? '',
    })),
);

const selectedCycle = computed(() => CYCLE_ITEMS.find((i) => i.id === values.value.cycle) ?? { id: '', name: '' });

async function save() {
    const valid = await validate();
    if (valid) {
        const mappedValues = { ...values.value };
        await updateEventSeries({ id: seriesId.value, ...mappedValues });
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
